import defaultConfig, { useAmplifyInit } from 'common';
import React, { createContext, ReactNode } from 'react';

interface AmplifyContextType {
  isInitialized: boolean;
  error: Error | null;
  signInWithRedirect: (params: any) => Promise<any>;
}

export const AmplifyContext = createContext<AmplifyContextType>({
  isInitialized: false,
  error: null,
  signInWithRedirect: async () => {
    throw new Error('AmplifyContext not initialized');
  },
});

interface AmplifyProviderProps {
  children: ReactNode;
}

export const AmplifyProvider: React.FC<AmplifyProviderProps> = ({ children }) => {
  const { isInitialized, error, signInWithRedirect } = useAmplifyInit({
    ...defaultConfig,
    appSync: {
      authenticationType: 'apiKey',
    },
  });

  if (error) {
    console.error('Error initializing Amplify:', error);
    return <div>Error initializing application. Please check the console for details.</div>;
  }

  if (!isInitialized) {
    return <div>Initializing application...</div>;
  }

  return (
    <AmplifyContext.Provider value={{ isInitialized, error, signInWithRedirect }}>
      {children}
    </AmplifyContext.Provider>
  );
};
